import React, { useState } from "react";
import "../assets/css/main.css"; // Assure-toi que ton CSS global est bien chargé
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ loading: false, success: null, error: null });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t("Emailsent"));
    setStatus({ loading: false, success: t("Emailsent"), error: null });
  };
  
  

  return (
    <section id="contact" className="contact section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>{t("ContactTitle")}</h2>
        <p>{t("ContactAccroche")}</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        {/* Informations */}
        <div className="info-wrap" data-aos="fade-up" data-aos-delay="200">
          <div className="row gy-5">
            <div className="col-lg-4">
              <div className="info-item d-flex align-items-center">
                <i className="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h3>{t("ContactAddress")}</h3>
                  <p>Paris, France</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="info-item d-flex align-items-center">
                <i className="bi bi-telephone flex-shrink-0"></i>
                <div>
                  <h3>{t("ContactCall")} </h3>
                  <p>+33 6</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="info-item d-flex align-items-center">
                <i className="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h3>{t("ContactEmail")}</h3>
                  <p>hovig.abechian@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay="300">
          <div className="row gy-4">
            <div className="col-md-6">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12">
              <input
                type="text"
                className="form-control"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12">
              <textarea
                className="form-control"
                name="message"
                rows="6"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="col-md-12 text-center">
              {status.loading && <div className="loading">Loading...</div>}
              {status.error && <div className="error-message">{status.error}</div>}
              {status.success && <div className="sent-message">{status.success}</div>}

              <button type="submit">{t("ContactSend")}</button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
